import { useEffect, useState } from 'react'

const fetchURL = async (url, offset = 0) => {
  const urlToFetch = new URL(url)
  urlToFetch.searchParams.append('offset', offset)

  const res = await global.fetch(urlToFetch.toString())
  const json = await res.json()

  if (json.totalFound > 100) {
    const newOffset = offset + 100
    const nextPageJson = await fetchURL(`${urlToFetch}`, newOffset)

    json.content = [...json.content, ...nextPageJson.content]
  }

  return json
}

const useFetchOpenings = (url) => {
  const [fetchResponse, setFetchResponse] = useState()
  const [isFetchLoading, setFetchLoading] = useState(false)
  const [fetchError, setFetchError] = useState(false)

  useEffect(() => {
    if (url) {
      const abortController = new global.AbortController()
      const { signal } = abortController

      const fetchData = async () => {
        try {
          setFetchLoading(true)

          const json = await fetchURL(url)

          if (!signal.aborted) {
            setFetchResponse(json)
          }
        } catch (error) {
          if (!signal.aborted) {
            setFetchError(error)
          }
        } finally {
          if (!signal.aborted) {
            setFetchLoading(false)
          }
        }
      }

      fetchData()
    }
  }, [url]) // eslint-disable-line react-hooks/exhaustive-deps

  return { isFetchLoading, fetchResponse, fetchError }
}

export { useFetchOpenings }
